import { render, staticRenderFns } from "./BookingRecord.vue?vue&type=template&id=7977270c&"
import script from "./BookingRecord.vue?vue&type=script&lang=js&"
export * from "./BookingRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports